export const getRandomColor = (colors: string[]): string => {
  if (colors.length <= 0) return "gray.300";
  const randomIndex = Math.floor(Math.random() * colors.length);
  return colors[randomIndex];
};
